import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-122e6ece"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "editor-page" }
const _hoisted_2 = { class: "editor-page__wrapper" }
const _hoisted_3 = {
  ref: "canvas",
  width: "600",
  height: "600"
}
const _hoisted_4 = { class: "editor-page__control" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("save and play")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("canvas", _hoisted_3, null, 512)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_base_button, {
        onClick: _withModifiers(_ctx.saveLevelAndRedirect, ["prevent"]),
        onKeypress: _withKeys(_withModifiers(_ctx.saveLevelAndRedirect, ["prevent"]), ["enter"]),
        tag: "a",
        href: "/game"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["onClick", "onKeypress"])
    ])
  ]))
}